import {
  Container,
  Grid,
  Box,
  ButtonBase,
  Button,
  useTheme,
  Typography,
  Avatar,
  Grow,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import React, { useState, useEffect, useRef } from "react";

import Axios from "axios";
import { Helmet } from "react-helmet-async";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Loading } from "../../components/shared/loading";
import { Link } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { TypingQuote } from "../../components/shared/TypingQuote";
import { HeroParticles } from "../../components/shared/HeroParticles";
import { Reveal } from "../../components/shared/Reveal";
import { CollabCard } from "../../components/shared/CollabCard";

import InstagramEmbed from './instaEmbedded'

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const COLLABS = [
  {
    logo: "/static/scaleme.png",
    name: "ScaleMe.in",
    tagline: "AI Tech Advisory Partner",
    points: [
      "AI Technology Advisor for the ScaleMe platform",
      "AI-based networking and communication systems",
      "Automation solutions for SME engagement",
    ],
    link: "https://scaleme.in",
  },
  {
    logo: "/static/zaplo.png",
    name: "Ziplo.ai",
    tagline: "Enterprise AI Agent Testing Partner",
    points: [
      "Testing and evaluation of enterprise AI agents",
      "Governance and compliance for AI deployments",
      "Reliable rollout of AI agents at scale",
    ],
    link: "https://ziplo.ai",
  },
  // CodeSquare Labs - commented out for now
  // {
  //   logo: "/static/csl.png",
  //   name: "CodeSquare Labs",
  //   tagline: "Technology Partner",
  //   points: [
  //     "CSL manages sales, branding, and digital marketing",
  //     "Arawinz builds and maintains web platforms, mobile apps, and backend systems",
  //   ],
  //   link: "https://codesquarelabs.com",
  // },
];

const useStyles = makeStyles((theme) => ({
  nounderline: {
    "&:hover": { textDecoration: "none" },
  },
  "@keyframes heroAuroraDrift1": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)", opacity: 0.7 },
    "33%": { transform: "translate(-12%, 18%) scale(1.2)", opacity: 0.95 },
    "66%": { transform: "translate(20%, -10%) scale(0.9)", opacity: 0.55 },
  },
  "@keyframes heroAuroraDrift2": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)", opacity: 0.55 },
    "50%": { transform: "translate(22%, 18%) scale(1.15)", opacity: 0.85 },
  },
  "@keyframes heroAuroraDrift3": {
    "0%, 100%": { transform: "translate(0, 0) scale(0.95)", opacity: 0.45 },
    "50%": { transform: "translate(-18%, -22%) scale(1.1)", opacity: 0.7 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  "@keyframes heroPremiumFadeUp": {
    from: { opacity: 0, transform: "translateY(40px) scale(0.98)", filter: "blur(8px)" },
    to: { opacity: 1, transform: "translateY(0) scale(1)", filter: "blur(0)" },
  },
  "@keyframes heroAccentExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroCtaGlow": {
    "0%, 100%": { boxShadow: "0 4px 24px rgba(199,125,199,0.35), 0 0 0 0 rgba(255,255,255,0.4)" },
    "50%": { boxShadow: "0 6px 36px rgba(224,184,224,0.65), 0 0 0 6px rgba(255,255,255,0)" },
  },
  "@keyframes orbDrift": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(14px, -12px) scale(1.12)" },
  },
  "@keyframes orbDriftAlt": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(-16px, 10px) scale(1.08)" },
  },
  heroSection: {
    position: "relative",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 50%, #1a001a 100%)",
    minHeight: "55vh",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  heroAurora: {
    position: "absolute",
    inset: 0,
    zIndex: 0,
    overflow: "hidden",
    pointerEvents: "none",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      borderRadius: "50%",
      filter: "blur(80px)",
      willChange: "transform, opacity",
    },
    "&::before": {
      width: "65%",
      height: "85%",
      background:
        "radial-gradient(circle, rgba(155,59,155,0.55), transparent 70%)",
      top: "-25%",
      left: "-15%",
      animation: "$heroAuroraDrift1 22s ease-in-out infinite",
    },
    "&::after": {
      width: "55%",
      height: "75%",
      background:
        "radial-gradient(circle, rgba(199,125,199,0.45), transparent 70%)",
      bottom: "-20%",
      right: "-10%",
      animation: "$heroAuroraDrift2 26s ease-in-out infinite",
    },
  },
  heroAuroraAccent: {
    position: "absolute",
    width: "45%",
    height: "55%",
    top: "10%",
    right: "25%",
    borderRadius: "50%",
    filter: "blur(70px)",
    background:
      "radial-gradient(circle, rgba(76,0,76,0.6), transparent 70%)",
    zIndex: 0,
    pointerEvents: "none",
    willChange: "transform, opacity",
    animation: "$heroAuroraDrift3 18s ease-in-out infinite",
  },
  heroOrb: {
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(60px)",
    pointerEvents: "none",
    zIndex: 0,
  },
  heroOrbOne: {
    width: 340,
    height: 340,
    top: "-16%",
    right: "6%",
    background:
      "radial-gradient(circle, rgba(199,125,199,0.35), transparent 68%)",
    animation: "$orbDrift 9s ease-in-out infinite",
  },
  heroOrbTwo: {
    width: 300,
    height: 300,
    bottom: "-22%",
    left: "2%",
    background:
      "radial-gradient(circle, rgba(155,59,155,0.3), transparent 68%)",
    animation: "$orbDriftAlt 11s ease-in-out infinite",
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    color: "#ffffff",
    textAlign: "center",
    padding: "48px 20px",
  },
  heroEyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "2.4px",
    textTransform: "uppercase",
    color: "#e0b8e0",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(199,125,199,0.35)",
    borderRadius: 30,
    padding: "6px 16px",
    marginBottom: 18,
    animation: "$heroPremiumFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) both",
    "&::before": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "#c77dc7",
      boxShadow: "0 0 10px #c77dc7",
    },
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.6rem)",
    fontWeight: 700,
    letterSpacing: "-0.01em",
    lineHeight: 1.15,
    marginBottom: "12px",
    animation: "$heroPremiumFadeUp 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.2s both",
    "& span": {
      display: "inline-block",
      fontWeight: 400,
      backgroundImage:
        "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
      backgroundSize: "200% auto",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      color: "transparent",
      animation: "$heroShimmerSweep 5s linear infinite",
    },
  },
  heroAccent: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto 20px",
    borderRadius: 2,
    animation: "$heroAccentExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.9rem, 1.6vw, 1.05rem)",
    fontWeight: 300,
    opacity: 0.92,
    maxWidth: "520px",
    margin: "0 auto 28px",
    lineHeight: 1.6,
    animation: "$heroPremiumFadeUp 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.7s both",
  },
  heroButton: {
    background: "linear-gradient(135deg, #ffffff 0%, #f5e8f5 100%)",
    color: "#4c004c",
    textDecoration: "none",
    padding: "12px 34px",
    fontSize: "0.9rem",
    fontWeight: 600,
    borderRadius: "30px",
    textTransform: "none",
    letterSpacing: "0.3px",
    border: "1px solid rgba(255,255,255,0.6)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    animation:
      "$heroPremiumFadeUp 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.95s both, $heroCtaGlow 3s ease-in-out 2s infinite",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "& .MuiButton-label, & .MuiSvgIcon-root": {
      color: "#4c004c",
    },
    "&:hover": {
      background: "linear-gradient(135deg, #ffffff 0%, #e0b8e0 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 10px 30px rgba(199,125,199,0.5)",
    },
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: "8px",
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#777777",
    textAlign: "center",
    maxWidth: "450px",
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  serviceCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    width: "100%",
    height: 280,
    cursor: "pointer",
    transition: "all 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
    border: "1px solid rgba(76,0,76,0.05)",
    [theme.breakpoints.down("sm")]: {
      height: 240,
      borderRadius: 16,
    },
    [theme.breakpoints.down("xs")]: {
      height: 200,
    },
    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow: "0 24px 50px rgba(76, 0, 76, 0.25)",
      borderColor: "rgba(155,59,155,0.2)",
    },
    "&:hover $serviceImg": {
      transform: "scale(1.06)",
    },
    "&:hover $serviceAccent": {
      width: 60,
    },
    "&:hover $serviceArrow": {
      background: "rgba(155,59,155,0.85)",
      borderColor: "rgba(255,255,255,0.4)",
      transform: "translateX(4px)",
    },
    "&:hover $serviceTitle": {
      transform: "translateY(-2px)",
    },
  },
  serviceImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    border: "none",
    transition: "transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)",
  },
  serviceOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to top, rgba(26,0,26,0.95) 0%, rgba(26,0,26,0.65) 28%, rgba(26,0,26,0.1) 55%, transparent 75%)",
    pointerEvents: "none",
  },
  serviceContent: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "20px 22px 22px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      padding: "16px 18px 18px",
    },
  },
  serviceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  serviceAccent: {
    width: 24,
    height: 2,
    background:
      "linear-gradient(90deg, #c77dc7 0%, #ffffff 100%)",
    borderRadius: 2,
    transition: "width 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
  },
  serviceArrow: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.14)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.22)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    "& svg": {
      fontSize: 14,
      color: "#ffffff",
    },
  },
  serviceTitle: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#ffffff",
    lineHeight: 1.3,
    letterSpacing: "-0.005em",
    transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.85rem",
    },
  },
  testimonialWrapper: {
    position: "relative",
    maxWidth: 720,
    margin: "0 auto",
    // Stable floor so the absolutely positioned inactive slides never
    // cause the section height to jump between quotes of different length.
    minHeight: 180,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      minHeight: 220,
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 260,
    },
  },
  testimonialSlide: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    opacity: 0,
    transform: "translateY(16px)",
    transition: "all 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
    pointerEvents: "none",
  },
  testimonialSlideActive: {
    opacity: 1,
    transform: "translateY(0)",
    position: "relative",
    pointerEvents: "auto",
  },
  testimonialCard: {
    position: "relative",
    background: "#ffffff",
    borderRadius: 20,
    padding: "44px 40px 36px",
    textAlign: "center",
    overflow: "hidden",
    border: "1px solid rgba(76,0,76,0.06)",
    boxShadow: "0 8px 28px rgba(76,0,76,0.06)",
    [theme.breakpoints.down("xs")]: {
      padding: "34px 24px 28px",
      borderRadius: 16,
    },
  },
  testimonialQuoteMark: {
    position: "absolute",
    top: 14,
    left: 24,
    fontSize: "4rem",
    color: "rgba(155,59,155,0.1)",
    fontFamily: "Georgia, serif",
    fontWeight: 700,
    lineHeight: 0.85,
    pointerEvents: "none",
    userSelect: "none",
    [theme.breakpoints.down("xs")]: {
      fontSize: "3rem",
      top: 10,
      left: 16,
    },
  },
  testimonialAvatarWrapper: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    marginBottom: 20,
    marginTop: 4,
  },
  testimonialAvatarRing: {
    position: "relative",
    width: 64,
    height: 64,
    padding: 2,
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, #c77dc7 0%, #9b3b9b 60%, #4c004c 100%)",
  },
  testimonialAvatar: {
    width: "100% !important",
    height: "100% !important",
    border: "2px solid #ffffff",
    background: "#f0e6f0",
  },
  testimonialQuote: {
    fontSize: "1rem",
    lineHeight: 1.75,
    color: "#3a3a3a",
    fontWeight: 400,
    fontStyle: "italic",
    maxWidth: 560,
    margin: "0 auto 20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.92rem",
    },
  },
  testimonialAccent: {
    width: 32,
    height: 2,
    background: "linear-gradient(90deg, #4c004c, #9b3b9b)",
    borderRadius: 2,
    margin: "0 auto 16px",
  },
  testimonialName: {
    fontWeight: 700,
    color: "#1a1a1a",
    fontSize: "0.95rem",
    letterSpacing: "-0.01em",
    marginBottom: 4,
  },
  testimonialProf: {
    color: "#9b3b9b",
    fontSize: "0.62rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1.6px",
  },
  testimonialNav: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    marginTop: 28,
  },
  testimonialArrow: {
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: 12,
    border: "1px solid rgba(76, 0, 76, 0.18)",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    color: "#4c004c",
    "&:hover": {
      background: "linear-gradient(135deg, #4c004c, #6b1b6b)",
      color: "#ffffff",
      borderColor: "transparent",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 18px rgba(76,0,76,0.32)",
    },
  },
  testimonialDots: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
  },
  testimonialDot: {
    width: 6,
    height: 6,
    padding: 0,
    border: 0,
    display: "block",
    borderRadius: "50%",
    background: "rgba(76, 0, 76, 0.18)",
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      background: "rgba(76, 0, 76, 0.4)",
    },
  },
  testimonialDotActive: {
    width: 28,
    borderRadius: 4,
    background:
      "linear-gradient(90deg, #4c004c, #9b3b9b, #c77dc7)",
  },
  partnersSection: {
    background: "linear-gradient(160deg, #4c004c 0%, #3a003a 40%, #2d002d 100%)",
    padding: "56px 0 48px",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "radial-gradient(circle at 50% 0%, rgba(155,59,155,0.15) 0%, transparent 60%)",
      pointerEvents: "none",
    },
  },
  partnersSectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#ffffff",
    textAlign: "center",
    marginBottom: 6,
    position: "relative",
    zIndex: 1,
  },
  partnersSectionSub: {
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.45)",
    textAlign: "center",
    maxWidth: 400,
    margin: "0 auto 36px",
    lineHeight: 1.5,
    position: "relative",
    zIndex: 1,
  },
  partnersMarquee: {
    display: "flex",
    overflow: "hidden",
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 80,
      zIndex: 2,
    },
    "&::before": {
      left: 0,
      background: "linear-gradient(90deg, #4c004c, transparent)",
    },
    "&::after": {
      right: 0,
      background: "linear-gradient(270deg, #2d002d, transparent)",
    },
  },
  partnersTrack: {
    display: "flex",
    gap: "20px",
    animation: "$marqueeScroll 30s linear infinite",
    "&:hover": {
      animationPlayState: "paused",
    },
    [theme.breakpoints.down('sm')]: {
      gap: "14px",
    },
  },
  "@keyframes marqueeScroll": {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-50%)" },
  },
  partnerCard: {
    minWidth: 150,
    height: 80,
    borderRadius: 16,
    background: "rgba(255,255,255,0.95)",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 20px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": {
      background: "#ffffff",
      boxShadow: "0 8px 28px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-3px)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
      height: 65,
      borderRadius: 12,
      padding: "10px 16px",
    },
  },
  partnerImg: {
    maxWidth: "100%",
    maxHeight: "50px",
    objectFit: "contain",
    border: "none !important",
    [theme.breakpoints.down('sm')]: {
      maxHeight: "40px",
    },
  },
  // Video Testimonials
  videoSection: {
    padding: "36px 0 32px",
    background: "transparent",
  },
  videoSectionTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 4,
  },
  videoSectionSub: {
    fontSize: "0.78rem",
    color: "#888",
    textAlign: "center",
    maxWidth: 380,
    margin: "0 auto 24px",
    lineHeight: 1.5,
  },
  videoCard: {
    borderRadius: 20,
    overflow: "hidden",
    background: "#ffffff",
    border: "1px solid rgba(76,0,76,0.06)",
    boxShadow: "0 2px 16px rgba(76,0,76,0.04)",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    position: "relative",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 36px rgba(76, 0, 76, 0.1)",
      borderColor: "rgba(76, 0, 76, 0.1)",
    },
  },
  videoCardHeader: {
    padding: "10px 16px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  videoLabelRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  videoLabelDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #6b1b6b, #9b3b9b)",
  },
  videoLabelText: {
    fontSize: "0.62rem",
    fontWeight: 600,
    color: "#aaa",
    textTransform: "uppercase",
    letterSpacing: "1.2px",
  },
  videoBadge: {
    fontSize: "0.58rem",
    fontWeight: 600,
    color: "#bbb",
    background: "rgba(76,0,76,0.04)",
    padding: "2px 8px",
    borderRadius: 6,
    letterSpacing: "0.5px",
  },
  videoEmbed: {
    padding: "0 8px 8px",
    "& iframe": {
      borderRadius: "12px !important",
    },
    transform: "scale(0.92)",
    transformOrigin: "top center",
  },
  ceoSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    position: "relative",
    overflow: "hidden",
  },
  ceoQuote: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: "700px",
    margin: "0 auto 12px",
    position: "relative",
    zIndex: 1,
  },
  ceoName: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  ctaSection: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    padding: "38px 30px",
    textAlign: "center",
    boxShadow: "0 16px 44px rgba(76,0,76,0.25)",
    "&::before": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      borderRadius: "50%",
      top: -160,
      left: -100,
      background:
        "radial-gradient(circle, rgba(199,125,199,0.3), transparent 70%)",
      pointerEvents: "none",
    },
  },
  ctaTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: 8,
    letterSpacing: "-0.01em",
  },
  ctaSubtitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.72)",
    maxWidth: 440,
    margin: "0 auto 20px",
    lineHeight: 1.6,
  },
  ctaButton: {
    position: "relative",
    zIndex: 1,
    background: "#ffffff",
    color: "#4c004c",
    padding: "10px 24px",
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: 11,
    textTransform: "none",
    boxShadow: "0 8px 22px rgba(0,0,0,0.2)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "& .MuiButton-label, & .MuiSvgIcon-root": {
      color: "#4c004c",
    },
    "&:hover": {
      background: "#ffffff",
      transform: "translateY(-2px)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.3)",
    }
  },
  section: {
    padding: "40px 0",
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
  },
}));

export const Home = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const [tests, setTests] = useState();
  const [videoTests, setVideoTests] = useState();
  const [services, setServices] = useState();
  const [activeTest, setActiveTest] = useState(0);
  const testAutoRef = React.useRef(null);

  // Auto-rotate testimonials
  React.useEffect(() => {
    if (tests && tests.length > 1) {
      testAutoRef.current = setInterval(() => {
        setActiveTest((prev) => (prev + 1) % tests.length);
      }, 6000);
    }
    return () => { if (testAutoRef.current) clearInterval(testAutoRef.current); };
  }, [tests]);

  const goTestimonial = (dir) => {
    if (!tests) return;
    if (testAutoRef.current) clearInterval(testAutoRef.current);
    setActiveTest((prev) => (prev + dir + tests.length) % tests.length);
    testAutoRef.current = setInterval(() => {
      setActiveTest((prev) => (prev + 1) % tests.length);
    }, 6000);
  };
  const [clients, setClients] = useState();
  const [active, setActive] = useState(0);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 1);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        handleClick();
      }
    });

    Axios.get("/api/gethomedata", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setTests(res.data.tests);
        setServices(res.data.services);
        setClients(res.data.clients);
        setVideoTests(res.data.videotests)
        setIsloading(false);
      }
    });
  };

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Box className={classes.heroAurora} />
            <Box className={classes.heroAuroraAccent} />
            <Box className={`${classes.heroOrb} ${classes.heroOrbOne}`} />
            <Box className={`${classes.heroOrb} ${classes.heroOrbTwo}`} />
            <HeroParticles id="home-hero-particles" />
            <Container maxWidth="lg">
              <Box className={classes.heroContent}>
                <span className={classes.heroEyebrow}>
                  Arawinz Soft Solutions
                </span>
                <Typography className={classes.heroTitle}>
                  Transform Your Business
                  <br />
                  <span>With Innovative IT Solutions</span>
                </Typography>
                <Box className={classes.heroAccent} />
                <Typography className={classes.heroSubtitle}>
                  We build modern digital experiences that drive growth,
                  enhance efficiency, and deliver measurable results for your business.
                </Typography>
                <Button
                  className={classes.heroButton}
                  component={Link}
                  to="/our-services"
                  endIcon={<ArrowForwardIcon />}
                >
                  Explore Our Services
                </Button>
              </Box>
            </Container>
          </Box>

          {/* Services Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Expertise
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    IT solutions built around each business and its goals
                  </Typography>
                </Box>
              </Reveal>

              {services && (
                <Grid container spacing={3}>
                  {services.map((service, key) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={key}>
                      <Grow in={true} timeout={600 + key * 100}>
                        <ButtonBase
                          className={classes.nounderline}
                          component={Link}
                          to={"/service-details/" + service.serv_name.split(" ").join("-") + "/" + service.serv_id}
                          style={{ width: "100%", height: "100%" }}
                        >
                          <Box className={classes.serviceCard}>
                            <img
                              src={"/static/services/" + service.serv_image}
                              alt={service.serv_name}
                              className={classes.serviceImg}
                            />
                            <Box className={classes.serviceOverlay} />
                            <Box className={classes.serviceContent}>
                              <Box className={classes.serviceHeader}>
                                <Box className={classes.serviceAccent} />
                                <Box className={classes.serviceArrow}>
                                  <ArrowForwardIcon />
                                </Box>
                              </Box>
                              <Typography className={classes.serviceTitle}>
                                {service.serv_name}
                              </Typography>
                            </Box>
                          </Box>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Container>
          </Box>

          {/* Collaborations Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Collaborations
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Strategic partnerships driving innovation and growth
                  </Typography>
                </Box>
              </Reveal>

              <Grid container spacing={3} justifyContent="center">
                {COLLABS.map((collab, i) => (
                  <Grid item xs={12} sm={6} key={collab.name}>
                    <Grow in={true} timeout={600 + i * 200}>
                      <div style={{ height: "100%" }}>
                        <CollabCard
                          logo={collab.logo}
                          name={collab.name}
                          tagline={collab.tagline}
                          points={collab.points}
                          link={collab.link}
                        />
                      </div>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Testimonials Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Client Stories
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover how our solutions have made a difference
                  </Typography>
                </Box>
              </Reveal>

              {tests && tests.length !== 0 && (
                <Box className={classes.testimonialWrapper}>
                  {tests.map((item, i) => (
                    <Box
                      key={i}
                      className={`${classes.testimonialSlide} ${i === activeTest ? classes.testimonialSlideActive : ''}`}
                    >
                      <Box className={classes.testimonialCard}>
                        <Box className={classes.testimonialQuoteMark}>"</Box>
                        <Box className={classes.testimonialAvatarWrapper}>
                          <Box className={classes.testimonialAvatarRing}>
                            <Avatar
                              alt={item.test_name}
                              src={"/static/testms/" + item.test_image}
                              className={classes.testimonialAvatar}
                            />
                          </Box>
                        </Box>
                        <Typography className={classes.testimonialQuote}>
                          {item.test_msg}
                        </Typography>
                        <Box className={classes.testimonialAccent} />
                        <Typography className={classes.testimonialName}>
                          {item.test_name}
                        </Typography>
                        <Typography className={classes.testimonialProf}>
                          {item.test_prof}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                  {/* Navigation */}
                  <Box className={classes.testimonialNav}>
                    <button
                      type="button"
                      aria-label="Previous testimonial"
                      className={classes.testimonialArrow}
                      onClick={() => goTestimonial(-1)}
                    >
                      <ChevronLeftIcon style={{ fontSize: 20 }} />
                    </button>
                    <Box className={classes.testimonialDots}>
                      {tests.map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          aria-label={`Go to testimonial ${i + 1}`}
                          className={`${classes.testimonialDot} ${i === activeTest ? classes.testimonialDotActive : ''}`}
                          onClick={() => {
                            setActiveTest(i);
                            if (testAutoRef.current) clearInterval(testAutoRef.current);
                            testAutoRef.current = setInterval(() => {
                              setActiveTest((prev) => (prev + 1) % tests.length);
                            }, 6000);
                          }}
                        />
                      ))}
                    </Box>
                    <button
                      type="button"
                      aria-label="Next testimonial"
                      className={classes.testimonialArrow}
                      onClick={() => goTestimonial(1)}
                    >
                      <ChevronRightIcon style={{ fontSize: 20 }} />
                    </button>
                  </Box>
                </Box>
              )}
            </Container>
          </Box>

          {/* Video Testimonials Section */}
          {videoTests && videoTests.length > 0 && (
            <Box className={classes.videoSection}>
              <Container maxWidth="lg">
                <Reveal>
                  <Box>
                    <Typography className={classes.videoSectionTitle}>
                      Video Testimonials
                    </Typography>
                    <Typography className={classes.videoSectionSub}>
                      Witness the journey and success of our clients in their own words
                    </Typography>
                  </Box>
                </Reveal>

                <Grid container spacing={3} justifyContent="center">
                  {videoTests.map((videotest, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                      <Grow in={true} timeout={800 + i * 200}>
                        <Box className={classes.videoCard}>
                          <Box className={classes.videoCardHeader}>
                            <Box className={classes.videoLabelRow}>
                              <Box className={classes.videoLabelDot} />
                              <Typography className={classes.videoLabelText}>
                                Client Story
                              </Typography>
                            </Box>
                            <Typography className={classes.videoBadge}>
                              #{String(i + 1).padStart(2, '0')}
                            </Typography>
                          </Box>
                          <Box className={classes.videoEmbed}>
                            <InstagramEmbed url={videotest.video_url} />
                          </Box>
                        </Box>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              </Container>
            </Box>
          )}

          {/* Trusted Partners Section */}
          <Box className={classes.partnersSection}>
            <Typography className={classes.partnersSectionTitle}>
              Trusted Partners
            </Typography>
            <Typography className={classes.partnersSectionSub}>
              Celebrating successful partnerships with industry leaders
            </Typography>

            {clients && clients.length > 0 && (
              <Box className={classes.partnersMarquee}>
                <Box className={classes.partnersTrack}>
                  {/* Double the logos for seamless infinite scroll */}
                  {[...clients, ...clients].map((client, key) => (
                    <a
                      key={key}
                      href={client.site_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Box className={classes.partnerCard}>
                        <img
                          src={"/static/clients/" + client.image_url}
                          alt={client.name}
                          className={classes.partnerImg}
                        />
                      </Box>
                    </a>
                  ))}
                </Box>
              </Box>
            )}
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Reveal>
                <Box className={classes.ceoSection}>
                  <FormatQuoteIcon style={{ 
                    fontSize: 40, 
                    color: "rgba(255, 255, 255, 0.15)",
                    display: "block",
                    margin: "0 auto 16px"
                  }} />
                  <TypingQuote
                    text={`"At Arawinz, we blend innovation with dedication to deliver exceptional solutions. Our team's journey is marked by a relentless pursuit of excellence and a deep commitment to understanding and fulfilling our clients' needs. Together, we are more than just a team - we are architects of the future, crafting a smarter, more connected world."`}
                    className={classes.ceoQuote}
                  />
                  <Typography className={classes.ceoName}>
                    - Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Reveal>
            </Container>
          </Box>

          {/* CTA Section */}
          <Box style={{ padding: "40px 0 80px" }}>
            <Container maxWidth="md">
              <Reveal>
                <Box className={classes.ctaSection}>
                  <Typography className={classes.ctaTitle}>
                    Ready to Transform Your Business?
                  </Typography>
                  <Typography className={classes.ctaSubtitle}>
                    Let's discuss how we can help you achieve your goals with our innovative solutions.
                  </Typography>
                  <Button 
                    className={classes.ctaButton}
                    component={Link}
                    to="/get-in-touch"
                    startIcon={<PhoneIcon />}
                  >
                    Get In Touch
                  </Button>
                </Box>
              </Reveal>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};

